module.exports = __webpack_public_path__ + "img/p3_l.b8fad2fc.jpg";